"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.function.name");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const AccountPricing_1 = require("@components/molecules/AccountPricing");
const molecules_1 = require("@components/molecules");
const organisms_1 = require("@components/organisms");
const _utils_1 = require("@utils");
const _theme_1 = require("@theme"); // Component
var AccountPayment = function AccountPayment() {
    var _useLocalStorage = _utils_1.useLocalStorage('newUserTier', ''), tier = _useLocalStorage[0], setTier = _useLocalStorage[1];
    var _React$useState = react_1.default.useState(false), modalVisible = _React$useState[0], setModalVisible = _React$useState[1];
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        fullWidth: true,
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Header, {
        noPadding: true,
        marginBottom: true
    }, tier === 'digital' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Checkout"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Complete your selection"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "Please review your tier and click continue when ready. If you require additional support, please ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/contact"
    }, "contact us"), ".")), tier === 'community' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Checkout"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Complete your purchase"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "Please review your tier and enter your payment information. If you require additional support, please ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/contact"
    }, "contact us"), ".")), tier === 'bespoke' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Checkout"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Complete your application"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "Please review your tier and enter your payment information. If you require additional support, please ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/contact"
    }, "contact us"), ".")))), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        shortPadding: true
    }, AccountInHeader_1.tiers.filter(function (t) {
        return t.name === tier;
    }).map(function (t) {
        return /*#__PURE__*/ react_1.default.createElement(StyledTierBox, {
            key: t.name
        }, /*#__PURE__*/ react_1.default.createElement(AccountPricing_1.ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, {
            src: "/images/accounts/" + tier + "Header.png",
            objectFit: "contain"
        })), /*#__PURE__*/ react_1.default.createElement(AccountPricing_1.TierName, null, _utils_1.capitalize(t.name)), /*#__PURE__*/ react_1.default.createElement(AccountPricing_1.List, null, t.features.map(function (feature, i) {
            return /*#__PURE__*/ react_1.default.createElement("li", {
                key: i,
                dangerouslySetInnerHTML: {
                    __html: feature
                }
            });
        })), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Trigger, {
            onClick: function onClick() {
                return setModalVisible(true);
            }
        }, "See The Full List"));
    })), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement("div", null, /*#__PURE__*/ react_1.default.createElement(organisms_1.PaymentForm, {
        tier: tier,
        setTier: setTier
    }))), /*#__PURE__*/ react_1.default.createElement(atoms_1.Modal, {
        visible: modalVisible,
        setVisible: setModalVisible
    }, /*#__PURE__*/ react_1.default.createElement(molecules_1.TierComparison, null)));
}; // Styling
var StyledLink = styled_components_1.default(gatsby_1.Link).withConfig({
    displayName: "AccountPayment__StyledLink",
    componentId: "zn1ybt-0"
})(["color:", ";"], _theme_1.palette.brown);
var StyledTierBox = styled_components_1.default(AccountPricing_1.TierBox).withConfig({
    displayName: "AccountPayment__StyledTierBox",
    componentId: "zn1ybt-1"
})(["", "{position:sticky;top:40px;}"], _utils_1.mediaQuery('tablet'));
exports.default = AccountPayment;
